module.exports = __webpack_public_path__ + "static/media/card-game-prize.fdac9c28.png";